









import { Component, Vue, Prop} from 'vue-property-decorator';
import { Effect } from '@/game/effect';
import Timer from '@/views/Timer.vue';

@Component({
  name: 'effects',
  components: {
    timer: Timer
  }
})
export default class Effects extends Vue {

  @Prop() public effects!: Effect[];

}
